import Api from "./Api";

export default {
  findParts(obj) {
    return Api().post("part/findParts", obj);
  },
  starProduct(part) {
    return Api().post("part/starProduct", { part });
  },
  fetchRelatedProducts(catIdObj) {
    return Api().post("part/fetch-related-products", catIdObj);
  },
  getCarouselProducts(user) {
    return Api().get('part/carousel-products', { 
      params: { user }
    });
  },
};
